import {LucideArrowRight, LucideStar, LucideQuote} from "lucide-react";
import {BolFireStrikePage} from "../../pages/HomePage";

const reviewTestimonialData: testimonialProps[] = [
    {
        starCount: 5,
        nameOfReviewer: "Linaloljna",
        review: "Je moet een klein beetje oefenen en soms geduld hebben maar het gaat wel steeds beter naarmate je hem meer gebruikt. " +
            "Deze staaf is lang en dik dus dat is een pluspunt. Schraper is wel aan de kleine kant",
        productReviewed : "",
    },
    {
        starCount: 5,
        nameOfReviewer: "Marcel11286",
        review: "Maak er inmiddels altijd vuur mee in combinatie met verkoold katoen en " +
            "of zelf gemaakt lont van vaseline en hout schaaf. Met een beetje oefenen en vuur maken is kinderspel.",
        productReviewed : "",
    },
    {
        starCount: 5,
        nameOfReviewer: "nachtwandelaar",
        review: "Deze firestarter werkt heel goed. Binnen 1 minuut branden de watten al. Ik had nog nooit een Firestarter gebruikt. Hij ligt goed in de hand en is stevig.",
        productReviewed : "",
    },
    {
        starCount: 5,
        nameOfReviewer: "James397",
        review: "Heb al een paar vuurtjes kunnen maken met deze vuurmaker. Het grote oppervlak maakt schrapen een stuk makkelijker",
        productReviewed : "",
    },
]

interface testimonialProps {
    starCount: number;
    review: string;
    nameOfReviewer: string;
    productReviewed: string;
    imageAltText?: string;
}

export const ProductReviews = () => {

    const header = "VERTROUWD DOOR AVONTURIERS";
    const description = "Sluit je aan bij duizenden avonturiers die op onze magnesiumstaven vertrouwen.";

    return (
        <section id="reviews" className="py-24 bg-ink-950 border-t border-ink-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="text-center mb-16">
                    <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-ember-400 mb-3">
                        Reviews
                    </span>
                    <h2 className="font-display font-bold uppercase text-4xl lg:text-5xl text-ink-50 mb-4">
                        {header}
                    </h2>
                    <p className="text-xl text-ink-300 max-w-3xl mx-auto">
                        {description}
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {reviewTestimonialData.map(review =>
                        <ReviewTestimonial
                            key={review.nameOfReviewer}
                            starCount={review.starCount}
                            nameOfReviewer={review.nameOfReviewer}
                            review={review.review}
                            productReviewed={review.productReviewed}
                        />)}
                </div>

                <ReadAllReviewsLink />
            </div>
        </section>
    );
};

const ReviewTestimonial = (props: testimonialProps) => {
    return (
        <div className="relative flex flex-col bg-ink-800 rounded-2xl p-6 border border-ink-700 hover:border-ember-500/40 transition-colors">
            <LucideQuote className="absolute top-5 right-5 h-7 w-7 text-ink-700" />

            <div className="flex text-ember-400 mb-4">
                {Array.from({length: props.starCount}).map((_, index) => (
                    <LucideStar key={index} className="h-4 w-4" fill="currentColor" />
                ))}
            </div>

            <p className="text-ink-200 text-sm leading-relaxed flex-1">
                {props.review}
            </p>

            <div className="mt-5 pt-4 border-t border-ink-700">
                <p className="font-semibold text-ink-50">
                    {props.nameOfReviewer}
                </p>
                <p className="text-xs text-ink-400">
                    Geverifieerde aankoop via Bol.com
                </p>
            </div>
        </div>
    );
};

const ReadAllReviewsLink = () => {
    return (
        <div className="mt-12 flex justify-center">
            <a
                href={BolFireStrikePage}
                className="inline-flex items-center gap-2 text-lg font-semibold text-ember-400 hover:text-ember-300 transition-colors"
            >
                Lees alle reviews op Bol.com
                <LucideArrowRight className="h-5 w-5" />
            </a>
        </div>
    );
};
